import MainLayout from "@/components/layout/admin/MainLayout.vue";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import axios from "axios";
import CONFIG from "@/assets/js/config.custom.js";

export default {
  name: "reportCardGradingDetail",
  components: {
    MainLayout,
    Loading,
  },

  data() {
    return {
      isLoading: false,
      reportCardItemDetail: {},
      gradeName: '',
      termName: '',
      acdYearName: '',
      catOAItems: [],
      catCSItems: [],
      students: [],
      noDataMsg: CONFIG.NO_DATA_FOUND,
    };
  },

  methods: {
    async fetchReportCardItemDetail() {
      try {
        this.isLoading = true;
        const gradingId = this.$route.params.id;
        const response = await axios.get(`/report-card-grading-item/${gradingId}`);
        if (response.data) {
          this.reportCardItemDetail = response.data;
          this.gradeName = this.reportCardItemDetail.grade_name ?? '';
          this.termName = this.reportCardItemDetail.term_name ?? '';
          this.acdYearName = this.reportCardItemDetail.acd_year_name ?? '';

          const catOAItems = this.reportCardItemDetail.category_OA_items ?? [];
          const catCSItems = this.reportCardItemDetail.category_CS_items ?? [];
          
          this.catOAItems = catOAItems.map(i => ({ id: i.item_id, name: i.item_name }));
          this.catCSItems = catCSItems.map(i => ({ id: i.item_id, name: i.item_name }));
          
          const allItems = [...catOAItems, ...catCSItems];
          
          this.students = [{
            grading_id: this.reportCardItemDetail.id,
            student_id: null,
            student_no: this.reportCardItemDetail.student_no,
            student_name: this.reportCardItemDetail.student_name,
            items: allItems.map(i => ({
              item_id: i.item_id,
              item_name: i.item_name,
              category: i.category || (this.catOAItems.find(c => c.id === i.item_id) ? 18 : 19),
              value: i.value,
            })),
          }];
        }
      } catch (error) {
        this.handleError(error);
      } finally {
        this.isLoading = false;
      }
    },

    getItemValue(student, itemId) {
      const item = student.items.find(i => i.item_id === itemId);
      return item ? item.value : '';
    },

    proficiencyClass(value) {
      if (!value) return '';
      const v = value.toLowerCase();
      if (v.includes('strong')) return 'badge-strong';
      if (v.includes('proficient')) return 'badge-proficient';
      if (v.includes('developing')) return 'badge-developing';
      return '';
    },

    showList() {
      this.$router.push({ path: '/report-card-grading' });
    },

    handleError(error) {
      if (error.response && error.response.status === 401) {
        this.$store.commit('logout');
        window.location.replace('login');
      } else {
        console.error(error);
      }
    },
  },

  mounted() {
    this.fetchReportCardItemDetail();
  },
};
